import React from "react";
import { CenteredSiteBlock } from "../../routes/Home";
import { Box, Grid, styled, Typography, useTheme } from "@mui/material";
import { useIsMobile } from "../../hooks/responsive";
import { GradientTypo } from "../header/Header";

import { ReactComponent as DevelopAlliancesIcon } from "../../resources/images/svg/home/developAlliances.svg";
import diagram from "../../resources/images/png/home/alliances/diagram.png";
import { ReactComponent as WebcamIcon } from "../../resources/images/svg/home/webcam.svg";
import { ReactComponent as PinIcon } from "../../resources/images/svg/home/pin.svg";
import SpecialCard from "../card/SpecialCard";
import EventCard from "./EventCard";
import {
  useGetEventsDatesQuery,
  useGetEventsQuery,
} from "../../store/api/events";
import RainbowDivider from "../misc/RainbowDivider";

import weirdBG from "../../resources/images/svg/home/zoomIcon4.svg";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    position: "relative",
  };
});

const EventsSection = ({ proInfos }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  const { data: eventsData } = useGetEventsQuery({ activites: 0, authToken: null, offset: 0, limit: 100 });

  const { data: eventsDatesData } = useGetEventsDatesQuery(
    { ids: eventsData?.items?.map((e) => e.id) },
    { skip: !eventsData?.items },
  );

  const eventsWithDates = React.useMemo(() => {
    if (!eventsData || !eventsDatesData) return null;
    return eventsData.items.map((event) => {
      return {
        ...event,
        dates: eventsDatesData.dates.filter(
          (date) => parseInt(date.idevent) === parseInt(event.id),
        ),
      };
    });
  }, [eventsData, eventsDatesData]);

  const onlineEvents = React.useMemo(() => {
    if (!eventsWithDates) return [];
    return eventsWithDates.filter((e) => {
      if (e.dates.length === 0) return true;
      return e.dates.some((d) => {
        const place = d.lieux !== "" ? JSON.parse(d.lieux) : { visio: true };
        return ["true", true, undefined].includes(place.visio);
      });
    });
  }, [eventsWithDates]);

  const physicalEvents = React.useMemo(() => {
    if (!eventsWithDates) return [];
    return eventsWithDates.filter((e) => {
      return e.dates.some((d) => {
        const place = d.lieux !== "" ? JSON.parse(d.lieux) : { visio: true };
        return !["true", true].includes(place.visio);
      });
    });
  }, [eventsWithDates]);


  const onlineEventsCercles = React.useMemo(() => {
    if (!onlineEvents) return [];
    return onlineEvents.filter((element) => element.activites === 2);
  }, [onlineEvents]);

  const onlineEventsAteliers = React.useMemo(() => {
    if (!onlineEvents) return [];
    return onlineEvents.filter((element) => element.activites === 3);
  }, [onlineEvents]);


  const level = React.useMemo(() => {
    if (!proInfos) return null;
    return proInfos.niveau;
  }, [proInfos]);

  return (
    <Container className={"events-section"}>
      {/*<img*/}
      {/*  src={weirdBG}*/}
      {/*  alt=""*/}
      {/*  style={{*/}
      {/*    position: "absolute",*/}
      {/*    top: "50%",*/}
      {/*    left: "50%",*/}
      {/*    transform: "translate(-50%, -50%)",*/}
      {/*    zIndex: 1,*/}
      {/*  }}*/}
      {/*/>*/}
      <CenteredSiteBlock
        sx={{
          position: "relative",
          marginTop: (theme) => theme.spacing(isMobile ? 5 : 10),
          marginBottom: (theme) => theme.spacing(isMobile ? 5 : 10),
          display: "flex",
          flexDirection: "column",
          paddingLeft: "20px",
          paddingRight: "20px",
          zIndex: 10,
        }}
      >
       
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "column", md: "row" },
            //marginRight: "5vw",
            //marginLeft: "5vw",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "column", md: "row" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  flexWrap: "nowrap",
                  alignItems: "center",
                  justifyContent: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "flex-start",
                  },
                  width: "100%",
                }}
              >
                <DevelopAlliancesIcon
                  width={"62px"}
                  height={"62px"}
                  style={{
                    marginRight: "10px",
                    marginLeft: "10px",
                  }}
                />
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 500,
                    margin: 0,
                    width: { xs: "100%", sm: "100%", md: "auto" },
                    textAlign: "center",
                    fontSize: isMobile ? "30px" : "40px",
                  }}
                >
                  Développez vos alliances
                </Typography>
              </Box>
              <GradientTypo
                variant={"h2"}
                background={theme.palette.linearPro}
                sx={{
                  fontFamily: "YesevaOne",
                  textTransform: "lowercase",
                  textAlign: { xs: "center", lg: "left" },
                  margin: 0,
                  fontSize: isMobile ? "30px" : "40px",
                  width: "100%",
                  fontWeight: 500,
                  "&:first-letter": {
                    textTransform: "lowercase !important",
                  },
                }}
              >
                &nbsp;{`pour grandir ensemble`}
              </GradientTypo>
              <Typography
                sx={{
                  marginTop: 3,
                  marginBottom: 3,
                  maxWidth: 1350 / 2,
                  marginLeft: isMobile ? undefined : "10px",
                }}
              >
                 <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    margin: 0,
                  }}
                >
                  Participez à nos prochains événements :
                </Typography>
                <Typography
                  sx={{
                    marginTop: 2,
                  }}
                >
                  - Des CERCLES D'ECHANGES entre praticiens dotés de la même ouverture d'esprit et des mêmes fondamentaux éthiques, pour partager, en petit comité et en confiance, vos expériences, regards, défis et ressources et grandir ensemble !
                </Typography>

                <Typography
                  sx={{
                    marginTop: 1,
                  }}
                >
                  - Des ATELIERS THEMATIQUES autour d'un expert pour recevoir de multiples conseils, affiner votre posture et vos connaissances et poser toutes vos questions !
                </Typography>

                <Typography
                  sx={{
                    fontWeight: 700,
                    marginTop: 2,
                    fontStyle: 'italic'
                  }}
                >
                   Ensemble, hissons nos pratiques holistiques vers toujours plus d'alignement, de responsabilité et d'efficacité thérapeutique !
                </Typography>

              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: { xs: "100%", lg: "50%" },
            }}
          >
            <img
              src={diagram}
              alt={"diagram"}
              style={{
                // width: "100%",
                maxWidth: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>

        {onlineEvents.length > 0 && proInfos && (
          <Box
            mt={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              width: "100%",
              zIndex: 1,
            }}
          >
            <SpecialCard
              sx={{
                backgroundColor: "#F3F2F5",
                display: "flex",
                justifyContent: "center",
                paddingLeft: 5,
                paddingRight: 5,
              }}
            >
              <WebcamIcon />
              <Typography
                sx={{
                  fontWeight: 700,
                  margin: 0,
                  marginLeft: 1,
                  padding: 0,
                  maxWidth: "150px",
                }}
              >
                {"En visio"}
              </Typography>
            </SpecialCard>
            
            {onlineEventsAteliers.length > 0 && proInfos && 
            (
              <>

              <Typography
                mt={3}
                sx={{
                  fontFamily: "Branding Bold",
                  fontWeight: "900",
                  fontSize: 23,
                  color: "black",
                }}
              >
                Ateliers {" "}
                <span
                  style={{
                    color: theme.palette.primary.main,
                  }}
                >
                  thématiques autour d'un expert
                </span>
              </Typography>
              <Grid container mt={2} mb={3} spacing={5}>
                {onlineEventsAteliers.map((event, i) => {
                  return (
                    <Grid
                      key={i}
                      size={{
                        xs: 12,
                        sm: 6,
                        md: 4,
                      }}
                      sx={{
                        width: "100%",
                      }}
                    >
                      <EventCard event={event} level={level} />
                    </Grid>
                  );
                })}
              </Grid>
              </>
            )}

            {onlineEventsCercles.length > 0 && 
            (
              <>

              <Typography
                mt={3}
                sx={{
                  fontFamily: "Branding Bold",
                  fontWeight: "900",
                  fontSize: 23,
                  color: "black",
                }}
              >
                Cercles{" "}
                <span
                  style={{
                    color: theme.palette.primary.main,
                  }}
                >
                  d'échanges entre praticiens
                </span>
              </Typography>
              <Grid container mt={2} mb={3} spacing={5}>
                {onlineEventsCercles.map((event, i) => {
                  return (
                    <Grid
                      key={i}
                      size={{
                        xs: 12,
                        sm: 6,
                        md: 4,
                      }}
                      sx={{
                        width: "100%",
                      }}
                    >
                      <EventCard event={event} level={level} />
                    </Grid>
                  );
                })}
              </Grid>
              </>
            )}


          </Box>
        )}

        {physicalEvents.length > 0 && (
          <Box
            mt={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <SpecialCard
              sx={{
                backgroundColor: "#F3F2F5",
                display: "flex",
                justifyContent: "center",
                paddingLeft: 5,
                paddingRight: 5,
              }}
            >
              <PinIcon />
              <Typography
                sx={{
                  fontWeight: 700,
                  margin: 0,
                  marginLeft: 1,
                  padding: 0,
                  maxWidth: "150px",
                }}
              >
                {"En présentiel"}
              </Typography>
            </SpecialCard>
            <Typography
              mt={3}
              sx={{
                fontFamily: "Branding Bold",
                fontWeight: "900",
                fontSize: 23,
                color: "black",
              }}
            >
              Soirées{" "}
              <span
                style={{
                  color: theme.palette.primary.main,
                }}
              >
                de connexion
              </span>
            </Typography>
            <Grid container mt={2} spacing={5}>
              {physicalEvents.map((event, i) => {
                return (
                  <Grid
                    key={i}
                    size={{
                      xs: 12,
                      sm: 6,
                      md: 4,
                    }}
                    sx={{
                      width: "100%",
                    }}
                  >
                    <EventCard event={event} level={level} />
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        )}
      </CenteredSiteBlock>
      <RainbowDivider />
    </Container>
  );
};

export default EventsSection;
